import React, { useEffect, useState } from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import api from '../api';

const RATES = { ETH: 1770, BTC: 63035, USDT: 1 };

function VaultOverview() {
  const [assets, setAssets] = useState([]);
  const [totalUSD, setTotalUSD] = useState(0);

  useEffect(() => {
    api.get('/api/assets/my-assets').then(res => {
      setAssets(res.data);
      const usd = res.data.reduce((sum, asset) => {
        const rate = RATES[asset.currency] || 1770;
        return sum + asset.amount * rate;
      }, 0);
      setTotalUSD(usd);
    });
  }, []);

  const areaData = [
    { month: 'Jan', balance: totalUSD * 0.3 },
    { month: 'Feb', balance: totalUSD * 0.4 },
    { month: 'Mar', balance: totalUSD * 0.6 },
    { month: 'Apr', balance: totalUSD * 0.7 },
    { month: 'May', balance: totalUSD * 0.85 },
    { month: 'Jun', balance: totalUSD },
  ];

  const getUSDValue = (asset) => {
    const rate = RATES[asset.currency] || 1770;
    return (asset.amount * rate).toFixed(2);
  };

  return (
    <div>
      <h2>Vault Balance Overview</h2>
      <div className="chart-box" style={{ maxWidth: '900px', margin: '0 auto' }}>
        <ResponsiveContainer width="100%" height={350}>
          <AreaChart data={areaData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis />
            <Tooltip formatter={(value) => `$${value.toLocaleString()}`} />
            <Area type="monotone" dataKey="balance" stroke="#3b82f6" fill="#3b82f6" fillOpacity={0.2} />
          </AreaChart>
        </ResponsiveContainer>
        <h3 style={{ marginTop: '2rem' }}>All Assets (Total: ${totalUSD.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })})</h3>
        <table>
          <thead>
            <tr><th>Asset</th><th>Amount</th><th>Currency</th><th>USD Value</th><th>Status</th></tr>
          </thead>
          <tbody>
            {assets.map(asset => (
              <tr key={asset.id}>
                <td>{asset.txHash?.slice(0, 10)}...</td>
                <td>{asset.amount}</td>
                <td>{asset.currency || 'ETH'}</td>
                <td>${getUSDValue(asset)}</td>
                <td>{asset.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
export default VaultOverview;